export const DEFAULT_DATA_COLLECTION_SLIEDER = {
  collections: [
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/abfdb1db-06f3-48c7-9398-b44d3e3197bf___591edda8414a4a1820f4113b2fbe1f67.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default label',
      description: 'Default description',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/abfdb1db-06f3-48c7-9398-b44d3e3197bf___591edda8414a4a1820f4113b2fbe1f67.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default label',
      description: 'Default description',
    },
  ],
  title: 'Title Default',
  description: 'Description Default',
}

export const DEFAULT_DATA_BANNER = {
  fullWidthNarrow: [
    {
      media: '(max-width: 48em)',
      srcSet:
        'https://lojavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/f406e99a-729f-46e0-b8b8-aecaca36f823___63a7f97a07baa43c696a19ed7b496b5f.jpg',
    },
    {
      media: '(min-width: 48em)',
      srcSet:
        'https://lojavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/f406e99a-729f-46e0-b8b8-aecaca36f823___63a7f97a07baa43c696a19ed7b496b5f.jpg',
    },
  ],
  fullWidthStatic: [
    {
      srcSet:
        'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/ea1e2670-1ea6-438b-baca-8d9e60c36248___782ef801f6296cf9d9e6891b12a3cf2f.png',
      media: '(max-width: 48em)',
      width: '450',
      height: '300',
    },
    {
      srcSet:
        'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/38acbcdc-a154-4b09-937b-9a471a21defe___b82c4856119677dda2eef50f89bb6be1.jpg',
      media: '(min-width: 48em)',
      width: '1800',
      height: '800',
    },
  ],
  static: [
    {
      media: '(max-width: 48em)',
      srcSet:
        'https://lojavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/f406e99a-729f-46e0-b8b8-aecaca36f823___63a7f97a07baa43c696a19ed7b496b5f.jpg',
    },
    {
      media: '(min-width: 48em)',
      srcSet:
        'https://lojavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/87cae919-6663-46cd-8702-48dff5816efa___63a7f97a07baa43c696a19ed7b496b5f.jpg',
    },
  ],
}

export const DEFAULT_DATA_NAVIGATION_CATEGORY = [
  {
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/b33391a8-ecd2-4cc2-a207-473801efdd0d___ce9f8f7b7166752c1226908551387bf7.png',
    href: '/',
    alt: 'Default alt',
    label: 'Default label',
    description: 'Default description',
  },
  {
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/b33391a8-ecd2-4cc2-a207-473801efdd0d___ce9f8f7b7166752c1226908551387bf7.png',
    href: '/',
    alt: 'Default alt',
    label: 'Default label',
    description: 'Default description',
  },
  {
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/b33391a8-ecd2-4cc2-a207-473801efdd0d___ce9f8f7b7166752c1226908551387bf7.png',
    href: '/',
    alt: 'Default alt',
    label: 'Default label',
    description: 'Default description',
  },
  {
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/b33391a8-ecd2-4cc2-a207-473801efdd0d___ce9f8f7b7166752c1226908551387bf7.png',
    href: '/',
    alt: 'Default alt',
    label: 'Default label',
    description: 'Default description',
  },
  {
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/b33391a8-ecd2-4cc2-a207-473801efdd0d___ce9f8f7b7166752c1226908551387bf7.png',
    href: '/',
    alt: 'Default alt',
    label: 'Default label',
    description: 'Default description',
  },
  {
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/b33391a8-ecd2-4cc2-a207-473801efdd0d___ce9f8f7b7166752c1226908551387bf7.png',
    href: '/',
    alt: 'Default alt',
    label: 'Default label',
    description: 'Default description',
  },
]

export const DEFAULT_DATA_NAVGATION_CATEGORY_TITLE_IMAGE = {
  titleimage: {
    '0': {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/bea28938-b536-4009-b6ef-af4905c42d3b___9cf7dc4b79db273d4d5f10714133cde9.png',
      alt: 'Image Default',
    },
    alt: 'Image Default',
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/851956e3-c8a0-4ec8-950d-ea2e4c4e9d84___e8c3cf2cfee85fdfb9af477029f0ee5c.png',
  },
  banners: [
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/535c9606-00f0-4368-8be9-852c6bbd6439___765045c8b1ee546bd7e57f7613009bff.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default Label',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/535c9606-00f0-4368-8be9-852c6bbd6439___765045c8b1ee546bd7e57f7613009bff.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default Label',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/535c9606-00f0-4368-8be9-852c6bbd6439___765045c8b1ee546bd7e57f7613009bff.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default Label',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/535c9606-00f0-4368-8be9-852c6bbd6439___765045c8b1ee546bd7e57f7613009bff.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default Label',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/535c9606-00f0-4368-8be9-852c6bbd6439___765045c8b1ee546bd7e57f7613009bff.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default Label',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/535c9606-00f0-4368-8be9-852c6bbd6439___765045c8b1ee546bd7e57f7613009bff.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default Label',
    },
  ],
}

export const DEFAULT_DATA_NAVIGATION_COLLECTION = {
  buttonText: 'Ver Seleção Default',
  collections: [
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/80bd4a99-59db-42f4-a674-20fa2e2ed42f___952083409e24c2cc6201ee83983e9ab3.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default label',
      description: 'Default description',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/80bd4a99-59db-42f4-a674-20fa2e2ed42f___952083409e24c2cc6201ee83983e9ab3.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default label',
      description: 'Default description',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/80bd4a99-59db-42f4-a674-20fa2e2ed42f___952083409e24c2cc6201ee83983e9ab3.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default label',
      description: 'Default description',
    },
    {
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/80bd4a99-59db-42f4-a674-20fa2e2ed42f___952083409e24c2cc6201ee83983e9ab3.png',
      href: '/',
      alt: 'Default alt',
      label: 'Default label',
      description: 'Default description',
    },
  ],
  title: 'Default Title',
  subtitle: 'Default Subtitle',
  buttonLabel: 'Button Default',
  buttonLink: 'https://www.vivara.com.br/',
  isAnchorButton: true,
}

export const DEFAULT_DATA_NAVIGATION_TAB_DISPLAY = {
  buttonText: 'Default buttonText',
  collections: [
    {
      collectionName: 'Default Collection',
      name: 'Default name',
      description: 'Default description',
      href: '/',
      link: '/',
      id: '137',
      alt: 'Default alt',
      imageName: 'Default ImageName',
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/4c48fd5e-da44-4b30-bb6f-531daf30f675___2423e3d33efef1f6d039927f5c3f57db.png',
    },
    {
      collectionName: 'Default Collection',
      name: 'Default name',
      description: 'Default description',
      href: '/',
      link: '/',
      id: '137',
      alt: 'Default alt',
      imageName: 'Default ImageName',
      src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/4c48fd5e-da44-4b30-bb6f-531daf30f675___2423e3d33efef1f6d039927f5c3f57db.png',
    },
  ],
  id: 'default-id',
  title: 'Default title',
  subtitle: 'Default subtitle',
  buttonTextColor: '#000000',
  buttonColor: '#ffa687',
}

export const DEFAULT_DATA_NAVIGATTION_TABS = {
  navigattionTabs: [
    {
      href: 'vivara.com.br',
      alt: 'Default alt',
      description: 'Default description',
      tabLabel: 'Default tabLabel',
      title: 'Default title',
      src1: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/0e2806e3-d614-4a4d-aedd-c1b053488767___12fa69d311b638b52c952aed5c46e4e3.png',
      src2: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/f8cb6b18-3d79-49b1-b049-d29f46f5d2b3___9a3834b948a8ba68757634b3677aadd9.png',
    },
    {
      href: 'vivara.com.br',
      alt: 'Default alt',
      description: 'Default description',
      tabLabel: 'Default tabLabel',
      title: 'Default title',
      src1: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/0e2806e3-d614-4a4d-aedd-c1b053488767___12fa69d311b638b52c952aed5c46e4e3.png',
      src2: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/f8cb6b18-3d79-49b1-b049-d29f46f5d2b3___9a3834b948a8ba68757634b3677aadd9.png',
    },
    {
      href: 'vivara.com.br',
      alt: 'Default alt',
      description: 'Default description',
      tabLabel: 'Default tabLabel',
      title: 'Default title',
      src1: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/0e2806e3-d614-4a4d-aedd-c1b053488767___12fa69d311b638b52c952aed5c46e4e3.png',
      src2: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/f8cb6b18-3d79-49b1-b049-d29f46f5d2b3___9a3834b948a8ba68757634b3677aadd9.png',
    },
  ],
}

export const DEFAULT_DATA_RICH_TEXT_FEATURED =
  '{"blocks":[{"key":"1q1ge","text":"Default content","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}'

export const DEFAULT_DATA_TIPLE_IMAGE_GALLERY = [
  {
    settings: {
      controlsOn: true,
      muteOn: true,
      playAuto: true,
      loopingVideo: true,
    },
    alt: 'Default alt',
    srcVideo:
      'https://images.vivara.com.br/Stores/vtex/videos/LIFE_VIVARA_MRB11-384x360.mp4',
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/43217fe4-6ede-4785-bb43-a3085615be0c___7dc02ce80d1567225bc24cee94851bed.png',
  },
  {
    settings: {
      controlsOn: true,
      muteOn: true,
      playAuto: true,
      loopingVideo: true,
    },
    alt: 'Default alt',
    srcVideo:
      'https://images.vivara.com.br/Stores/vtex/videos/LIFE_VIVARA_MRB11-384x360.mp4',
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/43217fe4-6ede-4785-bb43-a3085615be0c___7dc02ce80d1567225bc24cee94851bed.png',
  },
  {
    settings: {
      controlsOn: true,
      muteOn: true,
      playAuto: true,
      loopingVideo: true,
    },
    alt: 'Default alt',
    srcVideo:
      'https://images.vivara.com.br/Stores/vtex/videos/LIFE_VIVARA_MRB11-384x360.mp4',
    src: 'https://qavivara.vtexassets.com/assets/vtex.file-manager-graphql/images/43217fe4-6ede-4785-bb43-a3085615be0c___7dc02ce80d1567225bc24cee94851bed.png',
  },
]
